import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';
import { mapToHttpParams } from '@bcl/common-ui';

export interface StockProduct {
  id: number;
  name: string;
  amount: number;
  unit: string;
  supplier?: string;
  myAmount?: number;
  visitAmount?: number;
}

export type StockType = 'my' | 'visit' | 'compare';

@Injectable({
  providedIn: 'root',
})
export class CheckStockService {
  constructor(private http: HttpClient) {}

  public getStock(
    visitId: number | null,
    type: StockType
  ): Observable<StockProduct[]> {
    const url = `${environment.apiHost}/mobile/CheckStock`;
    const params = mapToHttpParams({
      visitId: visitId?.toString() || null,
      type,
    });

    return this.http.get<StockProduct[]>(url, { params });
  }
}
